
import { useLazyQuery, useQuery, useSubscription } from '@apollo/client';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { AgendaShift, AgendaShiftApplication, 
    AgendaUser, 
    AgendaUserType, 
    GetAgendaUserQuery, 
    GetAgendaUserQueryVariables, 
    ModelSortDirection, 
    OnCreateAgendaShiftApplicationByUserIdSubscription, 
    OnCreateAgendaShiftApplicationByUserIdSubscriptionVariables, 
    OnCreateAgendaShiftByUserIdSubscription, 
    OnCreateAgendaShiftByUserIdSubscriptionVariables, 
    ShiftAppsByComIdQuery, 
    ShiftAppsByComIdQueryVariables, 
    ShiftAppsByUserQuery, 
    ShiftAppsByUserQueryVariables, 
    ShiftsByUserQuery,
    ShiftsByUserQueryVariables,
    UsersByComIdQuery,
    UsersByComIdQueryVariables} from '../../graphql/API';
import { getAgendaUser, onCreateAgendaShiftApplicationByUserId, shiftAppsByComId, shiftAppsByUser, shiftsByUser, usersByComId } from './queries';
import { useAuthContext } from '../../contexts/AuthContext';
import useNotificationStorageService from '../services/NotificationStorageService';
import { useNotification } from '../../contexts/NotificationProvider';
import SubscriptionOpenShiftWrapper from './subscriptionWrappers/subscriptionOpenShiftWrapper';
import { IAppShift } from '../../Types/models';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Modal, Row, Spinner, Stack } from 'react-bootstrap';
import CustomModal from '../../components/Modals/CustomModal';
import Sidebar from '../services/Sidebar/Sidebar';
import { format } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import { IoArrowRedoCircleOutline } from 'react-icons/io5';
import { Pagination } from '@aws-amplify/ui-react';
import React from 'react';
import Cookies from 'js-cookie';
import useShiftApplicationService from '../services/ShiftApplicationService';
import useDateService from '../services/DateService';
import { PUBLIC_ID, SHIFTS_PER_PAGE } from '../../config';
import { FaBinoculars, FaPaperPlane } from 'react-icons/fa6';
import OpenShift from '../../components/OpenShift';

const OpenPublicShiftsByUserView = () => {
    // AUTH
    const {userId: AuthUserId} = useAuthContext();
    const userId = AuthUserId;
    // I18N
    const { t } = useTranslation();
    const savedLang = Cookies.get('language');
    const [locale, setLocale] = useState("en");
    // DATE SERVICES
    const {getTIMEZONE, getNextMonday, getPastDate, getDateNow} = useDateService();
    // HOME SETTINGS
    const TIMEZONE = getTIMEZONE();
    // TIMEZONE
    const now = useMemo(() => getDateNow(new Date(), TIMEZONE), []);
    // NAVIGATION
    const navigate = useNavigate();
    const location = useLocation();
    // PARAMS
    // const { id } = useParams<{ id: string }>();
    // SHIFT APPLICATIONS
    const [newShifts, setNewShifts] = useState<AgendaShiftApplication[]>([]);
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    // PAGINATION
    const [pageTokens, setPageTokens] = React.useState([null]);
    const [totalPagination, setTotalPagination] = React.useState(1);
    const [currentPageIndex, setCurrentPageIndex] = React.useState(1);
    const [hasMorePages, setHasMorePages] = React.useState(true);
    const [dontUpdateAnymore, setDontUpdateAnymore] = useState(false);
    const [shiftsState, setShiftsState] = useState([]);
    // SUBSCRIPTION
    const [subscriptionKey, setSubscriptionKey] = useState(0);
    // NOTIFICATION
    const notificationContext = useNotification();
    const notificationCount = notificationContext?.notificationCount;
    const setNotificationCount = notificationContext?.setNotificationCount;
    const openShiftCount = notificationContext?.openShiftCount;
    const setOpenShiftCount = notificationContext?.setOpenShiftCount;
    const openShiftAcceptedCount = notificationContext?.openShiftAcceptedCount;
    const setOpenShiftAcceptedCount = notificationContext?.setOpenShiftAcceptedCount;
    const {updateNotificationModelCount} = useNotificationStorageService();
    // LINK
    const setOpenShiftLink = notificationContext?.setOpenShiftLink;


    const {data: dataUser, loading: loadingUser, error: errorUser, refetch: refetchUser} = 
            useQuery<GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser, 
                {variables: {userId: userId}});

    // const date = new Date();
    // date.setDate(date.getDate() - 1);
    // const yesterday = date.toISOString().split('T')[0];

    const [fetchShifts, {data, loading, error, refetch, fetchMore}] = 
        useLazyQuery<ShiftAppsByComIdQuery, ShiftAppsByComIdQueryVariables>(shiftAppsByComId);

    const [fetchShiftVerif, {data: dataShiftVerif, loading: loadingShiftVerif, 
        error: errorShiftVerif, refetch: refetchShiftVerif, fetchMore: fetchMoreShiftVerif}] = 
            useLazyQuery<ShiftsByUserQuery, ShiftsByUserQueryVariables>(shiftsByUser);
            
    const [fetchManagers, {data: dataManagers, loading: loadingManagers, error: errorManagers, 
        refetch: refetchManagersData, fetchMore: fetchMoreManagers}] = 
        useLazyQuery<UsersByComIdQuery, UsersByComIdQueryVariables >(usersByComId);
            
    const user = dataUser?.getAgendaUser;

  useEffect(() => {
    if (location.state && (location.state as any).refetchData) {
      refetch();
      refetchShiftVerif();
    }
  }, [location.state]);
    
    useEffect(() => {
        if (!user) return;
        if (!user.language) return;
        setLocale(user?.language);
    }, [user]);
  
    const getShifts = async (token: string) => { //date: Date, 
        return await fetchShifts({variables: {
            comId: user?.comId,
            limit: SHIFTS_PER_PAGE,
            nextToken: token,
            sortDirection: ModelSortDirection.ASC,
            startAt: {gt: getPastDate(1)},
            filter: {
              userId: {eq: PUBLIC_ID},
              deleted: {ne: true}, 
              accepted: {ne: true},
              confirmed: {ne: true},
              stopAt: {gt: now},
              // // startAt: {gt: getPastDate(1).split("T")[0]}, NOT GOOD
              // and: [
              //   // {stopAt: {lt: getNextMonday(new Date())}},
              //   {stopAt: {gt: now}},
              // ],
              // stopAt: {lt: getNextMonday(new Date())}
            }
            // filter: {accepted: {ne: true}, deleted: {ne: true}}//{attributeExists: false}, deleted: {attributeExists: false}} //ne: true ...not working here but in appsync yes
        }});
    }

    const getVerifShifts = async () => {
        await fetchShiftVerif({variables: {
            userId: userId,
            startAt: {gt: getPastDate(1)},
            sortDirection: ModelSortDirection.ASC, 
            // limit: SHIFTS_PER_PAGE,
            filter: {
                deleted: {ne: true}, 
                accepted: {eq: true},
                // confirmed: {ne: true},
                // startAt: {gt: getPastDate(1)},
                and: [
                    // {stopAt: {lt: getNextMonday(new Date())}},
                    {stopAt: {gt: now}},
                ],
                // stopAt: {lt: getNextMonday(new Date())}
            }
            // filter: {accepted: {ne: true}, deleted: {ne: true}}//{attributeExists: false}, deleted: {attributeExists: false}} //ne: true ...not working here but in appsync yes
        }});
    }

    useEffect(() => {
      setNotificationCount && setNotificationCount((notificationCount ?? 0) - 
        (openShiftCount ?? 0) - (openShiftAcceptedCount ?? 0));
      updateNotificationModelCount('openShift', 0);
      updateNotificationModelCount('openShiftAccepted', 0);
      setOpenShiftCount && setOpenShiftCount(0);
      setOpenShiftAcceptedCount && setOpenShiftAcceptedCount(0);
      setOpenShiftLink && setOpenShiftLink("");
    }, [location]);

    useEffect(() => {
      // if (dataUser && !loading) {
        getShifts(pageTokens[pageTokens.length - 1]);
        // console.log("USERS ->", users);
      // }
    }, [dataUser, loading]);

    useEffect(() => {
        if (!user) return;
        if (!user.comId) return;
        // getShifts(pageTokens[pageTokens.length - 1]);
        getVerifShifts();
        fetchManagers({variables: {
            comId: user?.comId, 
            sortDirection: ModelSortDirection.DESC, 
            // limit: 10, 
            filter: {
                suspended: {ne: true},
                type: {eq: "MANAGER" as AgendaUserType}
        }}});
    }, [user]);

    const managers = dataManagers?.usersByComId?.items || [];
  
    useEffect(() => {
      if (data && data.shiftAppsByComId && !dontUpdateAnymore) {
        const newShifts = data.shiftAppsByComId.items;
        const newToken = data.shiftAppsByComId.nextToken;
        // console.log('newToken', newToken)
        setShiftsState(newShifts); // Met à jour la liste des utilisateurs
        if (newToken) {
          setPageTokens((prevTokens) => [...prevTokens, newToken]); // Ajoute un nouveau token
          setHasMorePages(true);
        } else {
          setHasMorePages(false); // Pas de token suivant, fin de la pagination
        }
      }
    }, [data]);
    
    useEffect(() => {
      if (hasMorePages) {
        setTotalPagination(pageTokens.length);
      } else {
        setTotalPagination(pageTokens.length - 1);
      }
    },[hasMorePages]);
    
    const handlePageChange = async (pageIndex: any) => {
      setDontUpdateAnymore(true);
      setCurrentPageIndex(pageIndex);
  
      const selectedToken = pageTokens[pageIndex - 1]; // Récupérer le token de la page sélectionnée
      if (selectedToken !== undefined) {
        const { data: { shiftAppsByComId: { items: newShifts, nextToken: newNextToken } } } = await getShifts(selectedToken);
  
        if (newShifts.length !== 0) {
          setShiftsState(newShifts);
          SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
          if (newNextToken && !pageTokens.includes(newNextToken)) {
            setPageTokens((prevTokens) => [...prevTokens, newNextToken]);
          }
        } else {
          if (hasMorePages) {
            setHasMorePages(false);
          }
        }
      }
    };
    
    const handleNextPage = async () => {
      setDontUpdateAnymore(true);
        const nextToken = pageTokens[currentPageIndex];
  
        if (nextToken) {
          const { data: { shiftAppsByComId: { items: newShifts, nextToken: newNextToken } } } = await getShifts(nextToken);
  
          if (newNextToken) {
            setShiftsState(newShifts);
            SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
            
            if (!pageTokens.includes(newNextToken)) {
                setPageTokens((prevTokens) => [...prevTokens, newNextToken]);
            }
            setCurrentPageIndex(currentPageIndex + 1);
          } else {
            if (newShifts.length > 0) {
              setShiftsState(newShifts);
              SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
              setCurrentPageIndex(currentPageIndex + 1);
              // removeLastPagination();
              setHasMorePages(false);
            } else {
              if (hasMorePages) {
                // removeLastPagination();
                setHasMorePages(false);
              }
            }
            // setHasMorePages(false); // Si pas de nextToken, on désactive la pagination
          }
          // console.log(pageTokens);
  
          // setCurrentPageIndex(currentPageIndex + 1); // Mise à jour de l'index de la page
        } else {
          console.error("Next token is undefined or null");
        }
    };
  
    const handlePreviousPage = async () => {
      if (currentPageIndex > 1) {
        const prevToken = pageTokens[currentPageIndex - 2];
        const { data: { shiftAppsByComId: { items: prevShifts, nextToken: newNextToken } } } = await getShifts(prevToken);
  
        setShiftsState(prevShifts);
        // setPageTokens(pageTokens.slice(0, -1)); 
        // if (hasMorePages) {
        //  setHasMorePages(nextToken ? true : false);
        // }
        SHIFTS_PER_PAGE > 1 ? setTotalPagination(pageTokens.length) : setTotalPagination(pageTokens.length - 1);
        setCurrentPageIndex(currentPageIndex - 1);
      }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setNewShifts([]);
        }, 1000 * 60 * 5); // 5 minutes
        
        return () => clearTimeout(timer);
    }, [newShifts]);
  

    const handleSubscriptionError = () => {
        console.warn("Subscription error, retrying in 5s...");
        setTimeout(() => {
          setSubscriptionKey((prev) => prev + 1);
        }, 5000);
    };

    // const shifts = (data?.shiftAppsByComId?.items || []);
    // console.log('shifts', shifts);
    const shifts = shiftsState; //(data?.shiftAppsByUser?.items || []);
    const verifShifts = dataShiftVerif?.shiftsByUser?.items as AgendaShift[] || [];
    // const nextToken = data?.shiftAppsByUser?.nextToken;

    const mergedShifts = useMemo(() => {
        return [
            ...newShifts,
            ...shifts.filter(s =>
                !newShifts.some(n => n.shiftAppId === s?.shiftAppId) &&
                !verifShifts.some(v => v.shiftAppId === s?.shiftAppId)
            )
        ];
    }, [newShifts, verifShifts, shifts]);

    // Apollo
  if (!user) {
        return (
            <div className="spinnerContainer">
                {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
                <Spinner animation="border" role="status" className="spinner">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>   
            </div>
        )
    };
    // Apollo
    // if (error) {
    //     return <ApiErrorMessage key="error" title="Error fetching the comments" message={error?.message}/>
    // };
    
    // const loadMore = async () => {
    //     if (!nextToken || isFetchingMore) {
    //         return;
    //     };
    //     setIsFetchingMore(true);
    //     await fetchMore({variables: {nextToken}});
    //     setIsFetchingMore(false);
    // };

    // const goToOpenShift = () => {
    //     navigate('/open_shifts');
    // };

    const isNewShift = (shift: AgendaShiftApplication) => {
        return newShifts.some(c => c.shiftAppId == shift.shiftAppId);
    };

    // const mergedShifts = [...newShifts, ...shifts.filter(s => !newShifts.some(n => (n.shiftAppId === s?.shiftAppId)))];

    return (
        <>
          <div className="d-flex">
            <Sidebar user={user} />
            <div className="users-container flex-grow-1 p-3">
              <div className="users-container">
                <div className="tabs">
                    <div className="post_row justify-content-center d-flex" style={{position:'relative', width: 350 }}>
                        <div className='linkPostTeammate d-flex align-items-center justify-content-center gap-2' style={{width: 350 }}>
                            <FaPaperPlane size={30} color="#CCC" />
                            <span className='textTab'>{t('home.openShiftAvail')}</span>
                            {/* <FaBinoculars size={30} color="#CCC" />
                            <span className='textTab'>{t('home.openPublicShiftAvail')}</span> */}
                        </div>
                    
                        {/* <FaPaperPlane size={30} onClick={goToOpenShift} className="public_open_shift_link" /> */}
                    </div>
                </div>
                {user?.userId && (
                  <SubscriptionOpenShiftWrapper
                      key={subscriptionKey}
                      userId={user.userId}
                      subscriptionKey={subscriptionKey}
                      onNewShift={(shift) => {
                          setNewShifts((prev) => [shift, ...prev]);
                      }}
                      onError={handleSubscriptionError}
                  />
                )}
                <Stack direction="vertical" gap={3} className="w-100">
                { mergedShifts.map((shift, index) => {
                  return ( 
                    <OpenShift 
                          // shift={item}
                          shift={{
                              ...shift,
                              user: (shift as any)?.user || null,
                          } as IAppShift}
                          locale={locale}
                          includedDetails={true}
                          isNew={isNewShift(shift)}
                          user={user as AgendaUser}
                          nav={"OpenShift"}
                          managers={managers as AgendaUser[]}
                          isPublicShift={true}
                      />
                    )
                  }
                )}
                </Stack>
                <div className="pagination-container">
                  {/* <p>tokenLenght: {pageTokens.length}</p>
                  <p>pageIndex: {currentPageIndex}</p>
                  <p>hasMorePages: {hasMorePages.toString()}</p>
                  <p>currentPageIndex: {currentPageIndex}</p> */}
                  <h2 className="paginationTitle">{t('title.openshifts')}</h2>
                  
                  <Pagination
                    currentPage={currentPageIndex}
                    totalPages={totalPagination}//{hasMorePages ? pageTokens.length: pageTokens.length - 1} //{Math.ceil(pageTokens.length / 10)} // Supposons que chaque page ait 10 éléments
                    hasMorePages={hasMorePages}
                    onNext={handleNextPage}
                    // onPrevious={() => setCurrentPageIndex(currentPageIndex - 1)}
                    onPrevious={handlePreviousPage}
                    onChange={handlePageChange}
                    // onChange={(pageIndex) => setCurrentPageIndex(pageIndex)}
                    // showFirstLast
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      );
    
};

export default OpenPublicShiftsByUserView;
